<template>
  <div class="banner" :style="{backgroundImage: 'url('+ url +')'}"></div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      url: require('../assets/banner.png')
    }
  },
  watch: {},
  computed: {},
  methods: {},
  created () {},
  mounted () {}
}
</script>
<style scoped>
.banner {
  width: 100%;
  /* height: 500px; */
  padding-bottom: 42%;
  background-size: 100% 100%;
}
</style>